
const state = {
  menuType: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).menuType : '0',   //0.头部菜单模式   1.左侧菜单模式
  headerBg: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).headerBg : '#9A3634',   //头部颜色 相当于主题颜色
  MenuImg: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).MenuImg : require(`@/assets/menu/navbar_3.png`),   //菜单背景色
  MenuTheme: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).MenuTheme : '2', //主题下标
  headerColor: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).headerColor : '#ffffff', //头部字体颜色
  headerBorderColor: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).headerBorderColor : 'rgba(255,255,255,0.1)', //头部中间小边框颜色
  headerBorderTop: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).headerBorderTop : '5px solid #fff', //头部右侧箭头颜色
  closeBg: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).closeBg : '#9A3634', //关闭按钮颜色
  borderTopLeft: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).borderTopLeft : '1px solid white', //旋转箭头颜色
  leftBoxColor: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).leftBoxColor : '#fff', //左侧菜单的字体颜色
  leftBoxShow: true,  //控制显示隐藏侧边栏
  nowPath: '/',//当前选中的菜单路径
  totalOrPart: 2, //全屏/内嵌
  menuData: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).menuData : [],       //菜单数据
  menuItem: localStorage.getItem('Menu') ? JSON.parse(localStorage.getItem('Menu')).menuItem : []        //菜单模式1的单个菜单数据
}

const mutations = {
  changeValue: (state, obj) => {  //修改menu属性的公共方法
    state[obj.key] = obj.value
    localStorage.setItem('Menu', JSON.stringify(state))
  },
  changeLeftBox: (state, value) => {  //实现显示隐藏侧边栏
    state.leftBoxShow = value
  }
}
const actions = {

}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js